import { TEAM_ARI_PREFIX, USER_ARI_PREFIX } from '../types';
export var isUserARI = function isUserARI(ari) {
  return ari.startsWith(USER_ARI_PREFIX);
};
export var toUserId = function toUserId(ari) {
  if (isUserARI(ari)) {
    return ari.replace(USER_ARI_PREFIX, '');
  }
  throw new Error('Invalid UserARI');
};
export var toUserARI = function toUserARI(userId) {
  return isUserARI(userId) ? userId : "".concat(USER_ARI_PREFIX).concat(userId);
};
export var isTeamARI = function isTeamARI(ari) {
  return ari.startsWith(TEAM_ARI_PREFIX);
};
export var toTeamId = function toTeamId(ari) {
  if (isTeamARI(ari)) {
    return ari.replace(TEAM_ARI_PREFIX, '');
  }
  throw new Error('Invalid TeamARI');
};
export var toTeamARI = function toTeamARI(teamId) {
  return isTeamARI(teamId) ? teamId : "".concat(TEAM_ARI_PREFIX).concat(teamId);
};